import RelativeSumGameAnswer from "./RelativeSumGameAnswer";
import GamesQuestionBlock from "../GamesQuestionBlock";

export default function RelativeSumGameAnsweringBlock({currentQuestion, userSign, userAnswer}) {
    // Used in RelativeSumGameContent to display both question and answer
    // blocks

    // BUILD
    return (
        <div className={"grow flex flex-col space-y-8 justify-center items-center pb-24"}>
            <GamesQuestionBlock
                currentQuestion={currentQuestion} />
            <RelativeSumGameAnswer
                sign={userSign}
                answer={userAnswer} />
        </div>
    );
}